<template>
  <div class="px-4 py-2">
    <div class="border-b border-grey-lighter">
      <span>
        <img
          class="h-4 w-4 inline-block"
          src="https://static-exp1.licdn.com/sc/h/4h84fuysqdejyl8qkrxn19a7o"
        />
      </span>
      <span>
        <img
          class="h-4 w-4 inline-block"
          src="https://static-exp1.licdn.com/sc/h/4f062912bi2l81i5apt8764va"
        />
      </span>
      <span class="pl-1 text-xs text-gray-700">{{vote}}</span>
      <span class="px-1 text-xs text-gray-700">&bull;</span>
      <a href="#" class="text-xs text-gray-600 hover:underline hover:text-blue-500">{{comments}} comments</a>
    </div>
    <div class="flex  items-center py-2">
      <a href="#" class="font-semibold text-md hover:bg-gray-300 text-gray-700 px-1 py-1 rounded">
                  <svg
          viewBox="0 0 24 24"
          width="24px"
          height="24px"
          x="0"
          y="0"
          preserveAspectRatio="xMinYMin meet"
          class="inline-block"
          focusable="false"
        >
          <path
            d="M17.51,11L15.36,8a14.81,14.81,0,0,1-2.25-5.29L12.74,1H10.5A2.5,2.5,0,0,0,8,3.5V4.08a9,9,0,0,0,.32,2.39L9,9H4.66A2.61,2.61,0,0,0,2,11.4a2.48,2.48,0,0,0,.39,1.43,2.48,2.48,0,0,0,.69,3.39,2.46,2.46,0,0,0,1.45,2.92,2.47,2.47,0,0,0,0,.36A2.5,2.5,0,0,0,7,22h4.52a8,8,0,0,0,1.94-.24l3-.76H21V11H17.51ZM19,19H16.88l-3.41.82A6,6,0,0,1,12,20H7a0.9,0.9,0,0,1-.9-0.89s0-.07,0-0.14l0.15-1-1-.4a0.9,0.9,0,0,1-.55-0.83,0.93,0.93,0,0,1,0-.22L5,15.57,4.27,15a0.9,0.9,0,0,1-.39-0.74A0.88,0.88,0,0,1,4,13.82l0.46-.72L4,12.38a0.88,0.88,0,0,1-.14-0.51,1,1,0,0,1,1-.87H11.5L10.2,6.3a9,9,0,0,1-.33-2.37V3.38a0.5,0.5,0,0,1,.5-0.5h0.95a17.82,17.82,0,0,0,2.52,6.22L16.6,13H19v6Z"
            class="large-icon"
            style="fill: currentColor"
          />
        </svg>
        Like
      </a>
      <a href="#" class="font-semibold text-md hover:bg-gray-300 text-gray-700 ml-2 px-1 py-1 rounded ">
        <svg
          viewBox="0 0 24 24"
          width="24px"
          height="24px"
          x="0"
          y="0"
          preserveAspectRatio="xMinYMin meet"
          class="inline-block"
          focusable="false"
        >
          <path
            d="M18,10H6V9H18v1Zm4-5V22l-5-4H3a1,1,0,0,1-1-1V5A1,1,0,0,1,3,4H21A1,1,0,0,1,22,5ZM20,6H4V16H17.7L20,17.84V6Zm-4,6H8v1h8V12Z"
            class="large-icon"
            style="fill: currentColor"
          />
        </svg>
        Comment
      </a>
      <a href="#" class="font-semibold text-md hover:bg-gray-300 text-gray-700 ml-2 px-1 py-1 rounded">
        <svg
          viewBox="0 0 24 24"
          width="24px"
          height="24px"
          x="0"
          y="0"
          preserveAspectRatio="xMinYMin meet"
          class="inline-block"
          focusable="false"
        >
          <path
            d="M24,12h0a1.18,1.18,0,0,0-.36-0.84L14,2V8H11A10,10,0,0,0,1,18v4H2.87A6.11,6.11,0,0,1,9,16h5v6l9.63-9.14A1.18,1.18,0,0,0,24,12s0,0,0,0h0Zm-8,5.54V14H9a8.15,8.15,0,0,0-6,2.84A8,8,0,0,1,11,10h5V6.48L21.81,12Z"
            class="large-icon"
            style="fill: currentColor"
          />
        </svg>
        Share
      </a>
    </div>
  </div>
</template>
<script>
export default {
    props:[
        'vote',
        'comments'
    ]
}
</script>